export default function CustomCheckBox({
	title,
	icon,
	description,
	selectedTitles = [],
	onToggle,
	customHeightClass,
	label,
}) {
	const isChecked = selectedTitles.includes(title);

	const CheckboxIcon = ({ checked }) => (
		<div
			className={`w-5 h-5 flex items-center justify-center rounded-md border-2 transition-all duration-150 ${
				checked
					? "bg-green1 border-green1"
					: "bg-white border-gray-400 hover:border-green1"
			}`}
		>
			{checked && (
				<svg
					className="w-3 h-3 text-white"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="3"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<polyline points="20 6 9 17 4 12" />
				</svg>
			)}
		</div>
	);

	return (
		<div
			onClick={() => onToggle(title)}
			className={`cursor-pointer rounded-lg px-4 py-2 flex items-start gap-4 border ${
				isChecked ? "border-green1 bg-gray-50" : "border-gray-300"
			} hover:border-green1 transition-all duration-150 ${customHeightClass}`}
		>
			<div className="pt-1">
				<CheckboxIcon checked={isChecked} />
			</div>
			<div className="flex flex-col">
				<p className="text-[16px] text-[#222222] font-medium leading-tight">
					{label}
				</p>
				<p className="text-[12px] text-[#5e5e5e] leading-snug break-words max-w-[400px]">
					{description}
				</p>
			</div>
		</div>
	);
}
